"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Qué es finanza.lat?",
    answer:
      "Es una plataforma para controlar tus finanzas personales o de negocio. Puedes registrar ingresos, gastos, suscripciones, cuentas en distintas monedas y obtener reportes visuales al instante.",
  },
  {
    question: "¿Puedo usarlo gratis?",
    answer:
      "Sí. Tienes un plan gratis de hasta 3 cuentas. Luego puedes elegir el plan que se adapte mejor a ti o tu empresa.",
  },
  {
    question: "¿Funciona para negocios?",
    answer:
      "Sí. Finanza.lat fue creado para adaptarse tanto a personas como a negocios. Puedes gestionar múltiples cuentas por empresa, ver balances individuales y generar reportes por cliente.",
  },
  // {
  //   question: "¿Cómo ayuda finanza.lat con mis declaraciones de impuestos?",
  //   answer:
  //     "Finanza.lat genera reportes específicos para declaraciones tributarias en Perú, incluyendo informes para el IGV, Renta y otras obligaciones fiscales. Estos reportes están diseñados para facilitar el proceso de declaración y maximizar deducciones legítimas.",
  // },
  {
    question: "¿Qué métodos de pago aceptan?",
    answer:
      "Actualmente aceptamos pagos manuales (Yape, Plin, Transferencia, PayPal, Mercado Pago). Próximamente activaremos suscripciones automáticas.",
  },
  {
    question: "¿Puedo gestionar diferentes monedas?",
    answer:
      "Sí. Puedes tener cuentas en soles (PEN), dólares (USD), y otras monedas. Los reportes se agrupan por moneda automáticamente.",
  },
  {
    question: "¿Qué pasa si no pago a tiempo?",
    answer:
      " Tu cuenta pasará a modo de solo lectura y se pausará el ingreso de nuevas transacciones. Puedes reactivarla manualmente cuando realices el pago.",
  },
  {
    question: "¿Puedo invitar a alguien más a ver mis finanzas?",
    answer:
      "Próximamente. Estamos desarrollando funciones para compartir vistas o reportes con tu contador, socio o asesor.",
  },
];

export default function Faq() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <section id="faq" className="py-20 relative">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Preguntas
            <span className="bg-gradient-to-r from-chart-3 to-chart-4 text-transparent bg-clip-text ml-2">
              Frecuentes
            </span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Encuentra respuestas a las preguntas más comunes sobre finanza.lat
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-muted/60"
              >
                <AccordionTrigger className="text-left hover:no-underline py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
